<template>
    <transition name="el-fade-in-linear">
        <div class="submission-item submission-wrapper"
             v-show="!hidden"
             :id="'submission' + list.id">

            <div class="flex1" :class="'content ' + type"
                 @click.prevent="openLightbox(url)">
                <div class="remove-reason" v-if="isHumtogAdministrator && !!list.reason_remove">
                    <i>{{list.reason_remove}}</i>
                </div>
                <div class="info">
                    <!--<i class="el-icon-tickets"></i>-->
                    <router-link class v-text="list.channel_title"
                                 :to="channelUrl(list.channel_name)"
                                 @click.native="$event.stopImmediatePropagation()"></router-link>
                    <router-link :to="/l/+list.location.slug"
                                 @click.native="$event.stopImmediatePropagation()">({{list.location.name}})</router-link>
                   <!-- <span>({{list.location.name}})</span> -->

                    <router-link
                            @click.native="$event.stopImmediatePropagation()"
                            v-if="!list.deleted_by"
                            class="post_info"
                            v-text="'posted by ' + list.author.username"
                            :to="userUrl(list.author.username)">
                    </router-link>
                    <span
                            v-else
                            class="post_info"
                            v-text="'[deleted]'">
                    </span>
                    <span>
                        <router-link
                                @click.native="$event.stopImmediatePropagation()"
                                class="date time_ago" v-text="date" :to="url"></router-link>
                    </span>
                </div>

                <div class="title-holder">
                    <h3 class="title hmt">
                        <a href="#"
                           v-if="lightbox"
                           class="flex-space v-ultra-bold">
                            {{ list.title }}
                        </a>
                        <router-link v-else :to="url" class="flex-space v-ultra-bold"
                                     @click.native="$event.stopImmediatePropagation()">{{ list.title }}</router-link>
                        <span class="new-link-url">
                            <a :href="list.content.url"
                               v-if="type === 'link'"
                               target="_blank"
                               class="source">
                              {{ list.content.domain }}
                            </a>
                        </span>
                    </h3>
                    <span class="separator" v-if="type === 'Question'">
            <!--  <p v-text="minimize(list.content.description)" class="font_weight_noraml"></p>-->
                    </span>
                    <span class="separator" v-if="type === 'img'">
            <!-- <p v-text="minimize(list.content.description)" class="font_weight_noraml"></p>-->
                    </span>
                    <span class="separator" v-if="type === 'link'">
<!--                        <p>"Auto-Summary"</p>-->
                        <!--<div v-html="list.content.description" class="font_weight_noraml"></div>-->
                        <!--<p v-text="$options.filters.truncate(list.content.description)"></p>-->
                    </span>
                    <span class="separator" v-if="type === 'text'">
                        <p v-text="minimize(list.content.description)" class="font_weight_noraml"></p>
                    </span>

                    <el-tag size="mini" type="danger" class="margin-left-half" v-if="list.deleted_at !== null">Deleted</el-tag>
                    <el-tag size="mini" type="danger" class="margin-left-half" v-if="list.nsfw">NSFW</el-tag>
                    <el-tag size="mini" type="danger" class="margin-left-half" v-if="list.newsworthy">Newsworthy
                    </el-tag>
                </div>

                <div class="thudm" @click.stop>
                    <div v-if="isLoggedIn"
                         @click="vote(1)"
                         :class="list.uservote > 0 ? 'upvotedon animated fadeIn' : 'upvotedoff fadeOut'"

                         class="htudvm">
                            <span v-if="list.uservote > 0"
                                  class="htuv"
                                  size="small">
                                Upvoted
                            </span>

                        <span v-else
                              class="htuv"
                              size="small">
                              Upvote
                            </span>
                        <span>|</span>
                        <span type="primary" class="htudvc">{{ list.votes }}</span>
                    </div>

                    <div v-else
                         class="htudvm"
                         @click="loginIn">
                        <span class="htuv" size="small">
                           Upvote
                        </span>
                        <span>|</span>
                        <span type="primary" class="htudvc">{{ list.votes }}</span>
                    </div>

                    <span v-if="isLoggedIn" @click="vote(-1)">
                        <span class="dbtm"
                              v-if="list.uservote < 0"
                              size="small">
                            Downvoted
                        </span>
                        <span class="dbtm"
                              v-else
                              size="small">
                            Downvote
                        </span>
                    </span>

                    <span v-else
                          class="dbtm"
                          size="small"
                          @click="loginIn">
                        Downvote
                    </span>

                    <span v-if="isHumtogAdministrator">
                        {{list.rate}}
                    </span>

                    <!--Comments-->
                    <router-link :to="url" class="comments-icon">
                        <el-tooltip
                                class="item"
                                content="Comments"
                                placement="top"
                                transition="false"
                                :open-delay="500"
                        ></el-tooltip>
                        <span
                                v-if="list.comments_count"
                                style="color: #979797 !important;"
                                class="count"
                                v-text="list.comments_count"
                        ></span>
                        <span
                                v-if="list.comments_count <= 1"
                                style="color: #979797 !important;"
                                class="count"
                        >&nbsp; Comment</span>
                        <span v-else style="color: #979797 !important;" class="count">&nbsp; Comments</span>

                        <slot name="action"></slot>
                    </router-link>


                    <!--Bookmark and Three dot options-->
                    <div class="actionsflex-space bookmark">
                        <div class="left">
                            <a @click.prevent="bookmark" href="#bookmark" class="bookamrks-icon">
                                <el-tooltip
                                        class="item"
                                        :content="bookmarked ? 'Unbookmark' : 'Bookmark'"
                                        placement="top"
                                        transition="false"
                                        :open-delay="500"
                                >
                                    <i
                                            style="margin: 0px"
                                            class="v-icon pointer"
                                            :class="bookmarked ? 'go-yellow v-unbookmark' : 'v-bookmark'"
                                    ></i>
                                </el-tooltip>
                            </a>
                            <div v-if="isHumtogAdministrator">
                                <div v-if="list.uservote === 0">
                                    <input type="text" v-model="bonus" style="width: 40px">
                                    <button @click.prevent="addBonus">
                                        <i class="el-icon-plus"></i>
                                    </button>
                                </div>
                                <div v-else>
                                    <input type="text" :value="list.uservote" style="width: 40px">

                                    <button @click.prevent="deleteBonus">
                                        <i class="el-icon-close"></i>
                                    </button>
                                </div>
                            </div>


                            <el-dropdown
                                    size="mini"
                                    type="primary"
                                    class="margin-left-1 more-icon"
                                    trigger="click"
                                    :show-timeout="0"
                                    :hide-timeout="0"
                            >
                                <i class="v-icon v-more-vertical darker-on-hover el-dropdown-selfdefine"></i>

                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-if="!owns" @click.native="report">Report</el-dropdown-item>

                                    <el-dropdown-item @click.native="hide" v-if="!owns">Hide</el-dropdown-item>

                                    <el-dropdown-item @click.native="markAsNSFW" v-if="showNSFW">NSFW</el-dropdown-item>

                                    <el-dropdown-item @click.native="markAsSFW" v-if="showSFW">Family Safe
                                    </el-dropdown-item>

                                    <el-dropdown-item @click.native="addNewsworthy" v-if="showNewsworthy">
                                        Newsworthy
                                    </el-dropdown-item>
                                    <el-dropdown-item @click.native="delNewsworthy" v-if="showDelNewsworthy">
                                        Not Newsworthy
                                    </el-dropdown-item>

                                    <el-dropdown-item
                                            v-if="owns "
                                            class="go-red"
                                            @click.native="destroy"
                                    >Delete
                                    </el-dropdown-item>

                                    <el-dropdown-item
                                            class="go-green"
                                            @click.native="approve"
                                            v-if="showApprove"
                                            divided
                                    >Approve
                                    </el-dropdown-item>

                                    <el-dropdown-item
                                            class="go-red"
                                            @click.native="disapprove"
                                            v-if="showDisapprove"
                                    >Disapprove
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                </div>
                <div v-if="showTextareaRemoveComment" class="remove-reason" @click.stop>
                    <textarea v-model="reasonRemoveText" id="textarea-remove-comment"></textarea>
                    <button v-if="reasonRemoveText" class="submit-btn" @click.prevent="disapprove"><b>Save</b></button>
                </div>

                <slot name="data"></slot>
            </div>

            <div class="post_images" >
                <!-- thumbnail -->
                <div :style="thumbnail" v-if="showThumbnail" @click.prevent="openLightbox(url)" class="thumbnail pointer"></div>
              <!--  <div v-else class="thumbnail pointer hide_border_p" v-html="firstImage(list.content)"></div>  -->
            </div>
            <div v-if="showLightBox">
                <el-dialog
                        :visible="true"
                        :width="'90%'"
                        class="submission-box"
                        @close="closeLightBox"
                >
                    <submission-page-content :url="url"></submission-page-content>
                </el-dialog>
            </div>
        </div>
    </transition>
</template>

<script>
    import Helpers from "../mixins/Helpers";
    import Submission from "../mixins/Submission";
    import SubmissionPageContent from "./SubmissionPageContent";

    export default {
        components: {SubmissionPageContent},
        props: {
            lightbox: {
                type: Boolean,
                default: false
            }
        },
        mixins: [Helpers, Submission],
        data() {
            return {
                errors: [],
                upvoted: false,
                downvoted: false,
                loading: false,
                status: 0,
                id: 0,
                deleted: '',
                showLightBox: false,
                showTextareaRemoveComment: false,
                reasonRemoveText: '',

            };
        },
        computed: {
            voteCount() {
                let count = 0
                for (let i in this.list.votes) {
                    count += this.list.votes[i].status
                }
                return count
            },

            thumbnail() {
                if (this.type === "link") {
                    return {
                        backgroundImage: "url(" + this.list.content.thumbnail_path + ")"
                    };
                } else if (this.type === "img") {
                    return {
                        backgroundImage: "url(" + this.list.content.thumbnail_path + ")"
                    };
                } else if (this.type === "text") {
                    return {
                        backgroundImage: "url(" + this.list.content.thumbnail_path + ")"
                    };
                }
            },

            showThumbnail() {
                return this.list.content.thumbnail || this.list.content.thumbnail_path;
            },

            url() {
                return this.submissionUrl(this.list);
            },

            date() {
                return this.parsDiffForHumans(this.list.created_at);
            }
        },
        filters: {
            truncate: function (text) {
                /*var string= test.trim().replace(/<\/?[^>]+(>|$)/g, "") ;
                         return   string.substring(0, 200);*/
                return (
                    text
                        .trim()
                        .replace(/&nbsp;/g, "")
                        .replace("<a.*?</a>", "")
                        .replace(/<\/?[^>]+(>|$)/g, "")
                        .substring(0, 200) + "..."
                );
            }
        },
        watch: {
            list: function (newValue) {
                console.log('watch list', newValue);
            }
        },
        methods: {
            openLightbox(url) {
                history.pushState('', '', url);
                this.showLightBox = true
            },
            closeLightBox() {
                history.back()
                this.showLightBox = false
            },
/* This is a wrong way to extract firstimage data. Temporarily commenting it out as it is often causing errors which prevent infinite scroll.
            firstImage(content) {
                if (!!content || !!content.description) {
                    let imageUrls = content.description.match(/(http(s?):)([/|.|\w|\s|-])*\.(?:jpg|gif|png)/g);

                    if (!!imageUrls) {
                        return `<img src="${imageUrls[0]}">`
                    }
                }
                return '<p></p>'
            }, */

            minimize(text) {
                if (!text) {
                    return ''
                }
                let description = text.substring(0, 240); // simply delegating to the global function
                //    let regex = /(<([^>]+)>)/gi;
                let regex = /<[^>]+>|&nbsp;/gi;
                return description.replace(regex, "");
            },
            loginIn() {
                this.mustBeLogin();
                // app.$message({
                //   message: "Oops, You Need To Login FIrst.",
                //   type: "error",
                //   showClose: true
                // });
            },

            embedOrOpen(event) {
                /*              if (this.type === "News") {
                                 this.$router.push(this.url);
                             }

                             if (this.type === "img") {
                                 this.showPhotoViewer(this.list.content);
                             } */
                this.$router.push(this.url);
            },

            /**
             * Deletes the submission. Only the author is allowed to make such decision.
             *
             * @return void
             */
            destroy() {
                axios.delete(`/submissions/${this.list.id}`)
                    .then((response) => {
                        app.$message({
                            message: response.data.message,
                            type: "success",
                            showClose: true
                        });
                        // if (response.data.message == 'Submission deleted.') {
                        //     this.list.deleted_by = true
                        // } else {
                            this.hidden = true;
                        // }

                    })
                    .catch(() => {
                        // this.hidden = false;
                    });
            },

            /**
             * Disapproves the submission. Only the moderators of channel are allowed to do this.
             *
             * @return void
             */
            disapprove() {
                axios.post('moderator/submissions/'+this.list.id+'/disapprove');
            }
        }
    };
</script>
<style scoped>
    .item {
        margin-right: 40px;
    }
</style>

<style lang="scss">
    .side-actions {
        visibility: hidden;
    }

    .submission-item {
        &:hover {
            background-color: #f5f8fa;
        }

        .separator {
            /*margin-left: 0.2em;*/
            /*margin-right: 0.2em;*/
            color: #3e3e3e;
        }

        .source {
            color: #979797;
            font-size: 14px;
            font-weight: 500;

            &:hover {
                text-decoration: underline;
            }
        }

        .new-link-url small {
            color: #5788d7 !important;
        }

        border: 1px solid #eaeef5;
        border-bottom: 2px solid #eaeef5;
        border-radius: 2px;
        padding: 0 1em;
        margin-bottom: 0.5em;
        background-color: #ffffff;

        .info {
            color: #979797;
            font-size: 80%;

            a {
                color: #686868;
                letter-spacing: 0.8px;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

        .title a {
            color: #333;
            display: inline;
        }

        .hmt {
            margin-top: 8px;
        }

        .content {
            /*padding: 1em;*/
            padding-right: 0;
            padding-bottom: 10px;
            padding-top: 10px;
            // margin-right: 1em;
        }

        .actions {
            margin-top: 0em;

            .left {
                a {
                    font-size: 13px;
                    font-weight: bold;
                    display: inline-flex;
                    align-items: center;
                    min-width: 80px;
                    color: #4c4b4b;
                }
            }

            .right {
                a {
                    font-size: 13px;
                    // font-weight: bold;
                }
            }

            i {
                color: #657786;
                font-size: 17px;
                margin-left: 1em;
            }

            .count {
                margin-left: 1em;
            }

            .date {
                color: #979797;
                font-size: 80%;
                font-weight: normal;

                &:hover {
                    text-decoration: underline;
                }
            }

            .comments-icon:hover {
                i,
                .count {
                    color: #78b38a;
                }
            }

            .bookamrks-icon:hover {
                i {
                    color: #edb431;
                }
            }

            .more-icon:hover {
                i {
                    color: #000;
                }
            }
        }

        .thumbnail {
            border: 1px solid #e3e3e3;
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
            border-radius: 0.2rem;
            height: 125px;
            width: 145px;
            overflow: hidden;
        }

        .no-thumbnail {
            border-right: 1px solid #e7e7e7;
        }

        .side-voting {
            padding-right: 1em;

            &:hover {
                cursor: pointer;

                i {
                    color: #db6e6e !important;
                }
            }
        }
    }

    .submission-item:hover {
        .side-actions {
            visibility: inherit;
        }
    }

    .set_background_color {
        background-color: #cccccc;
        border-radius: 7px;
        padding: 1px 10px;
    }

    .post_info {
        padding: 1px 10px;
    }

    .time_ago {
        font-weight: normal !important;
    }

    .font_weight_noraml {
        font-weight: normal !important;
        margin-top: 0px !important;
        margin-bottom: 0;
    }

    .hide_border_p {
        border: none !important;
    }

    .post_images {
        -webkit-box-align: center;
        align-items: center;
        display: flex;
    }

    .bookmark {
        text-align: right;
        display: none;
        float: right;
        margin-right: 7px;

        .left {
            display: flex;
            align-items: center;
        }
    }

    .submission-item:hover .bookmark {
        display: inline-block !important;
    }

    .new-link-url {
        display: inline;
        padding: 5px;
    }

    .new-link-url a {
        color: #5788d7 !important;
    }

    .title-holder {
        padding-bottom: 10px;
    }


 @media (max-width: 600px) {
    .submission-item .thumbnail {
        width: 80px;
        height: 80px;;
    }
      .post_info {
        padding: 1px;
    }
    .v-ultra-bold {
    font-size: 17px;
    }
    .submission-item .info {
     font-size: 10px;
}
.htudvm {
    width: 90px !important;
    font-size: 10px;
    padding: 5px;
}
.comments-icon {
    font-size: 10px;
 }
 .dbtm{
    font-size: 10px !important;
 }
 .font_weight_noraml {
    font-size: 15px !important;
}
.bookmark {
    display: none;
 }
 .submission-item:hover .bookmark {
     display: none !important;
 }
 .el-tag{
     font-size: 8px;
 }
.el-dialog__body {
    padding: 5px;
}
 }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Submission.vue